<label [attr.for]="'vuRole'">{{ ('Role' | translate) + ':' }}</label>
<select id="vuRole" [(ngModel)]="configuration.vuRole" (change)="onVuRoleChange($event)">
  <option *ngFor="let r of vuRoles" [ngValue]="r">{{ r | translate }}</option>
</select>
